import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {TuiButton, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface GateweeBulkConfirmDialogData {
  title: string;
  /** What the bulk action will do (already translated). */
  purpose: string;
  selectedCount: number;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'gatewee-bulk-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, TuiButton],
  template: `
    <div class="gw-p-6 gw-space-y-4">
      <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
        {{ data.title }}
      </h2>
      <p class="gw-text-sm gw-text-text-secondary">{{ data.purpose }}</p>
      <p class="gw-text-sm gw-font-medium gw-text-text-primary">
        {{
          'common.bulk.confirm.selectedCount'
            | translate : {count: data.selectedCount}
        }}
      </p>
      <div class="gw-flex gw-justify-end gw-gap-2 gw-pt-2">
        <button
          tuiButton
          appearance="secondary"
          type="button"
          (click)="cancel()"
        >
          {{ data.cancelLabel ?? ('common.actions.cancel' | translate) }}
        </button>
        <button
          tuiButton
          appearance="primary"
          type="button"
          (click)="confirm()"
        >
          {{ data.confirmLabel ?? ('common.actions.proceed' | translate) }}
        </button>
      </div>
    </div>
  `,
})
export class GateweeBulkConfirmDialogComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<
      boolean,
      GateweeBulkConfirmDialogData
    >,
  ) {}

  get data(): GateweeBulkConfirmDialogData {
    return this.context.data;
  }

  confirm(): void {
    this.context.completeWith(true);
  }

  cancel(): void {
    this.context.completeWith(false);
  }
}
